module.exports = __webpack_public_path__ + "static/media/LazyAz_web1.bde9a996.jpg";